import { DeleteTwoTone, PlusCircleTwoTone } from "@ant-design/icons";
import { useState } from "react";
import useInstruments from "../../api/hooks/useInstruments";
import { getResource } from "../../helpers/ResourcesHelper";
import Dropdown from "../inputs/Dropdown";
import Input from "../inputs/Input";
import { Disbursement } from "../models/Disbursement";
import { usePaymentTransactionContext } from "./PaymentTransactionContext";

interface DisbursementItemType {
  disbursement: Disbursement
}

export const DisbursementItem = (props: DisbursementItemType) => {

  const [showInvoiceInfo, setShowInvoiceInfo] = useState(false);

  const { disbursement } = props

  const { beneficiaries, lockedSide, buyCurrencyInfo, sellCurrencyInfo, disbursementInfoAsParameter, validateInput, setDisbursementHasChanged, disbursementsHasChanged }
    = usePaymentTransactionContext();

  const [instruments] = useInstruments();

  const onInstrumentChange = (item: any, disbursement: Disbursement) => {
    disbursement.instrument = item.value
    setDisbursementHasChanged(!disbursementsHasChanged)
  }

  return <>
    <div className="row">
      <div className="col-md-3 col-xs-12">
        <span className="label-visible">{getResource('Js_TH_Beneficiary')}</span>
        <div className="row">
          <Dropdown
            className={validateInput && disbursement.bankAccountId === 0 ? 'input-error' : ''}
            id={"beneId" + disbursement.key}
            name={"beneficiaryDropdown" + disbursement.key}
            title={getResource('SelectBeneficiary')}
            list={beneficiaries}
            onChange={(b: any) => { disbursement.beneficiaryId = b.BeneficiaryID; disbursement.bankAccountId = b.BankAccountID; setDisbursementHasChanged(!disbursementsHasChanged) }}
            select={{ value: `${disbursement.beneficiaryId}|${disbursement.bankAccountId}` }}
            disabled={disbursementInfoAsParameter}
          />
        </div>
      </div>
      <div className="col-md-3 col-xs-12">
        <span className="label-visible">{getResource('Label.Instrument')}</span>
        <div className="row">
          <Dropdown
            className={validateInput && disbursement && disbursement.instrument === '' ? 'input-error' : ''}
            id={"instrumentId" + disbursement.key}
            name="instrumentDropdown"
            title={getResource('SelectInstrument')}
            list={instruments}
            onChange={(item: any) => onInstrumentChange(item, disbursement)}
            select={{ value: disbursement.instrument }}
          />
        </div>
      </div>
      <div className="col-md-1°5 col-xs-12">
        <span className="label-visible">{getResource('Label.WeSend')}</span>
        <div className="row">
          <Input
            className={lockedSide === 'buy' && validateInput ? (disbursement.amount === 0 || isNaN(disbursement.amount) ? 'input-error' : '') : ''}
            type="number2"
            value={disbursement.amount}
            onValueChange={(value: any) => { disbursement.amount = value; setDisbursementHasChanged(!disbursementsHasChanged) }}
            decimalScale={(buyCurrencyInfo && buyCurrencyInfo.NumberOfDecimals) || 2}
            disabled={disbursementInfoAsParameter || lockedSide === 'sell'}
          />
        </div>
      </div>
      <div className="col-md-1°5 col-xs-12">
        <span className="label-visible">{getResource('Label.WePay')}</span>
        <div className="row">
          <Input
            className={lockedSide === 'sell' && validateInput ? (disbursement.otherAmount === 0 || (disbursement.otherAmount === null) ? 'input-error' : '') : ''}
            type="number2"            
            value={disbursement.otherAmount}
            onValueChange={(value: any) => { disbursement.otherAmount = value; setDisbursementHasChanged(!disbursementsHasChanged) }}
            decimalScale={(sellCurrencyInfo && sellCurrencyInfo.NumberOfDecimals) || 2}
            disabled={disbursementInfoAsParameter || lockedSide === 'buy'}
          />
        </div>
      </div>
      <div className="col-md-1 col-xs-12">
        <span className="label-visible">{getResource('Label.Fee')}</span>
        <div className="row">
          <Input type="text" disabled={true} value={(disbursement.fee || 0).toFixed(sellCurrencyInfo.NumberOfDecimals || 2)}
          />
        </div>
      </div>
      <div className="col-md-1 col-xs-12">
        <span className="label-visible">{getResource('Label.Reference')}</span>
        <div className="row">
          <input type="text" value={disbursement.reference}
            onChange={(item: any) => { disbursement.reference = item.target.value; setDisbursementHasChanged(!disbursementsHasChanged) }} />
        </div>
      </div>
      <div className="col-md-1 col-xs-12 center" >
        {!disbursementInfoAsParameter! && <DeleteTwoTone style={{ marginRight: '20px', marginTop: '10px' }} onClick={f => f} twoToneColor={"#34c521"} />}
        <PlusCircleTwoTone style={{ marginTop: '10px' }} onClick={(item: any) => { setShowInvoiceInfo(!showInvoiceInfo) }} twoToneColor={"#34c521"} />
      </div>
    </div>
  </>
}
